import clsx from 'clsx'
import React from 'react'
import { twMerge } from 'tailwind-merge'

import { calculatePriceWithPercent, getFloatPrice } from '../../../../helpers/price'

interface IProps {
  currency: string
  status: boolean
  price: string
  percent: number
  className?: string
}

export const PriceWithPercent: React.FC<IProps> = ({
  currency,
  status,
  price,
  percent,
  className,
}) => {
  const formated = Number(
    String(price)
      .replace(/[^\d.,-]/g, '')
      .replace(/,/g, '')
  )

  if (!status || formated < 0) {
    return <></>
  }

  return (
    <span
      className={twMerge(
        clsx(
          'absolute right-4 bottom-1/2 translate-y-1/2 text-SeabiscuitDark200ThemeColor/50 whitespace-nowrap text-[14px]',
          className
        )
      )}
    >
      {getFloatPrice(`${currency}${calculatePriceWithPercent(price, percent)}`)}
    </span>
  )
}
